import { Backdrop, CircularProgress } from '@mui/material'
import { useState } from 'react'
import { Fade } from 'utoniq-ui'

import { StorageImage } from '@/core'

/**
 * @description
 * CircularProgress型共通ローディングアイコン
 * Storageにpng画像がない場合、materia-uiデフォルトのCircularProgressを表示する
 */
export const Loading = () => {
  const [fallback, setFallback] = useState(false)

  return fallback ? (
    <Fade sx={{ display: 'grid', placeItems: 'center' }}>
      <CircularProgress />
    </Fade>
  ) : (
    <Fade>
      <StorageImage
        src="images/loading.png"
        height={50}
        width={50}
        alt="loading"
        onError={e => setFallback(true)}
      />
    </Fade>
  )
}

export const LoadingWithBackdrop = ({ open }: { open: boolean }) => {
  return (
    <Backdrop
      open={open}
      sx={{
        display: 'grid',
        placeItems: 'center',
        height: '100%',
        width: '100%',
        maxWidth: 600,
        margin: 'auto',
        zIndex: 1,
      }}
    >
      <Loading />
    </Backdrop>
  )
}
